<template>
  <div class="interview">
    <!--    <div class="interview-header">-->
    <!--      <button class="button hollow primary instructions"-->
    <!--              @click.prevent="this.$parent.showInstructions = true">-->
    <!--        Instructions-->
    <!--      </button>-->
    <!--    </div>-->

    <div v-show="!beginPresentInterview" class="transition">
      <h2 class="transition-title h3">Considering the Present</h2>
      <h3 class="h4">Where am I now? How satisfied am I with this area of my life?</h3>
      <p>As you proceed through the following portion of the exercise,
         keep these questions in mind. The objective is to create awareness and to serve as a baseline for the following
         step.</p>
      <h3 class="h4">How to score</h3>
      <p>Consider a "0" to be the complete absence of the category within your life, while considering a "10" to denote
         that there is nothing in you life that could improve as it relates to the current category.</p>
      <div class="next-step">
        <button @click="beginPresentInterview = true" class="button filled accent-1">Continue</button>
      </div>
    </div>

    <div v-show="!presentInterviewComplete && beginPresentInterview" class="questions present">
      <h2 class="questions-title h3">Considering the Present</h2>
      <p>Rate where you feel you are presently in each area of life.</p>

      <div v-for="(category, index) in categories" class="question" v-show="showQuestion('present', index)">
        <h6 class="label">{{ category.label }}</h6>
        <p class="desc">{{ category.desc }}</p>
        <div class="score">
          <span v-for="score in scores" @click="setCategoryScore('present', index, score)"
                :class="{'selected': isScoreSelected('present', index, score) }">{{ score }}</span>
        </div>
      </div>
    </div>

    <div v-show="presentInterviewComplete && !beginFutureInterview" class="transition">
      <h2 class="transition-title h3">Looking into Future</h2>
      <h3 class="h4">Where would I like to be one year from now?</h3>
      <p>Next, you will consider the same categories, but this time, consider where you would like to be in
         the future... one year from now.</p>
      <p>Note: Your current rating from the previous step will be displayed as reference. Also, you will not be able
         to select a value less than your current rating as it is impractical to wish the future be less satisfactory
         than the present. On another note: it is applicable to not seek change in any given category. As such, you
         may select the same rating as in the previous step.</p>
      <p class="example">What if I want less than I currently have in a specific category?</p>
      <p>Its okay to want less, if by doing so leads to greater satisfaction within that category. For example: when
         considering career, if you were looking to retire and if retiring would be an improvement on your current
         career status... despite no longer having a job/career, it would still be an improvement within this
         category.</p>
      <div class="next-step">
        <button @click="beginFutureInterview = true" class="button filled accent-1">Continue</button>
      </div>
    </div>

    <div v-show="beginFutureInterview && !futureInterviewComplete" class="questions future">
      <h2 class="questions-title h3">Looking into Future</h2>
      <p>Rate where you would like to be in each area of life one year from now.</p>

      <div v-for="(category, index) in categories" class="question" v-show="showQuestion('future', index)">
        <h6 class="label">{{ category.label }}</h6>
        <p class="desc">{{ category.desc }}</p>
        <div class="score">
          <span v-for="score in scores"
                @click="setCategoryScore('future', index, score)"
                :class="{'selected': isScoreSelected('future', index, score),
                        'disabled': isInvalidScore(index, score),
                        'present-score': isPresentScore(index, score)
                            }">
            {{ score }}
          </span>
        </div>
      </div>
    </div>

<!--    <div v-show="futureInterviewComplete" class="next-step">-->
<!--      <button class="button filled accent-1"-->
<!--              @click="this.$parent.interviewComplete = true; this.$parent.presentData = presentData;this.$parent.futureData = futureData;">-->
<!--        View Results-->
<!--      </button>-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  props: {
    categories: {
      type: Array
    },
  },
  data() {
    return {
      scores:                [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      presentData:           [],
      futureData:            [],
      beginPresentInterview: false,
      beginFutureInterview:  false
    };
  },
  mounted() {
    for (let i = 0; i < this.categories.length; i++) {
      this.presentData.push(null)
      this.futureData.push(null)
    }
  },
  computed: {
    presentInterviewComplete() {
      for (let i = 0; i < this.presentData.length; i++) {
        if (!this.presentData[i]) {
          return false;
        }
      }
      return true;
    },
    futureInterviewComplete() {
      for (let i = 0; i < this.futureData.length; i++) {
        if (!this.futureData[i]) {
          return false;
        }
      }
      return true;
    },
  },
  methods:  {
    setCategoryScore(period, index, score) {
      if (period === "present") {
        this.presentData[index] = score;
      } else if (period === "future") {
        this.futureData[index] = score;
        if((index + 1) === this.categories.length) {
          this.$parent.interviewComplete = true;
          this.$parent.presentData = this.presentData;
          this.$parent.futureData = this.futureData;
        }
      }
    },
    isScoreSelected(period, index, score) {
      if (period === "present") {
        if (this.presentData && this.presentData[index]) {
          return this.presentData[index] === score;
        }
      } else if (period === "future") {
        if (this.futureData && this.futureData[index]) {
          return this.futureData[index] === score;
        }
      }
      return false;
    },
    showQuestion(period, index) {
      if (period === "present") {
        if (this.presentData[index]) {
          return false;
        } else if (index === 0 && !this.presentData[0]) {
          return true;
        } else if (this.presentData[index - 1]) {
          return true;
        }
      } else if (period === "future") {
        if (this.futureData[index]) {
          return false;
        } else if (index === 0 && !this.futureData[0]) {
          return true;
        } else if (this.futureData[index - 1]) {
          return true;
        }
      }
      return false;
    },
    isPresentScore(index, score) {
      return this.presentData[index] === score;
    },
    isInvalidScore(index, score) {
      return this.presentData[index] > score;
    }
  }
}
</script>
